import axios from "axios";
import { API_URL } from "../constants";
import { ApiTokenEntry, ApiTokenScope } from "../types/ApiToken";

/** The MCP endpoint an AI client connects to — this API's own origin. */
export const MCP_ENDPOINT_URL = `${API_URL}/mcp`;

export async function fetchApiTokens(companyId: string): Promise<{ entries: ApiTokenEntry[] }> {
  const res = await axios.get(`${API_URL}/${companyId}/api-tokens`);
  return res.data;
}

/**
 * Creates a token. The `token` in the response is the only copy that will ever
 * exist — the backend stores a hash and has no endpoint that can show it again.
 */
export async function createApiToken(
  companyId: string,
  params: { name: string; scopes: ApiTokenScope[] }
): Promise<{ entry: ApiTokenEntry; token: string }> {
  const res = await axios.post(`${API_URL}/${companyId}/api-tokens`, params);
  return res.data;
}

export async function revokeApiToken(companyId: string, tokenId: string): Promise<{ message: string }> {
  const res = await axios.delete(`${API_URL}/${companyId}/api-tokens/${tokenId}`);
  return res.data;
}
